module.exports = __webpack_public_path__ + "img/18.72cc03c4.png";